import moment from "moment";
import { getStorageItem } from "../../../../utils/common-utils";

export const getPaymentInfo = () => {
  const { orderInfo } = getStorageItem("reservationInfo");

  return {
    purpose: "order.purchase",
    amount: orderInfo.payableAmount,
    currency: orderInfo.payableAmount.currency,
    description: "",
  };
};

export const getReservationExpiry = () => {
  const reservation = getStorageItem("reservationInfo");

  const startTime = moment();
  const endTime = moment(reservation.reservationExpiry);

  return moment(endTime).diff(startTime, "minutes");
};
